import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { authLoginSelector } from "../../features/auth/authLoginSlice";
import { Link, useNavigate } from "react-router-dom";

const PaymentSucessPopup = ({
  setPaymentSuccessPopup,
  PayCheckedInvoiceResponse,
  transactionIDs,
  setshowOutstanding,
  t,
}) => {
  const dispatch = useDispatch();
  const { userLogin } = useSelector(authLoginSelector);
  const navigate = useNavigate();
  return (
    <div>
      <dialog id="delete_dialog2" className="modal" open>
        <span className="modal-content">
          <div className="absolute top-0 right-0 mt-3 mr-4">
            <button
              id="ConfirmPickup"
              className="text-black font-medium hover:text-black-light focus:outline-none focus:text-black-light transition ease-in-out duration-150"
              onClick={() => {
                setPaymentSuccessPopup(false);
                setshowOutstanding(true);
              }}
            >
              <span className="text-xl">&times;</span>
            </button>
          </div>

          <div className="mt-8 text-justify font-semibold w-auto">
            {/* // {t("AcceptPickupMsg")} */}
            {/* {
                PayCheckedInvoiceResponse.map((response,index)=>{
                    response.transactionID
                })
              } */}
            {t("paymentSuccessPopup1")}
            <br />
            {t("paymentSuccessPopup2")} {transactionIDs} <br />
            <Trans
              i18nKey="paymentSuccessPopup3"
              components={[
                <span />,
                <Link
                  to="/orderstatus?tab=3"
                  state={{ Tab: 4, SubTab: 2 }}
                  onClick={() => {
                    // setspayCheckedInvoices(false);
                    setTimeout(() => window.location.reload(), 200);
                  }}
                  className="text-secondary-red"
                  style={{ cursor: "pointer" }}
                ></Link>,
              ]}
            />
          </div>
        </span>
      </dialog>
    </div>
  );
};

export default PaymentSucessPopup;
